// Social provider operational status. Updated manually when business state
// changes (사업자등록번호 발급, 검수 완료 등). Source-of-truth for the login UI:
// disabled providers are rendered greyed out + reason; warned providers stay
// active but show a small caveat under the button.
//
// Keep messages user-friendly — never expose provider error codes (KOE006, etc.).
//
// Last reviewed 2026-05-08:
//   kakao: 사업자등록번호 발급 후 비즈 앱 검수 → reactivate
//   naver: OAuth 검수 신청 후 통과 → remove warning

export const SOCIAL_PROVIDER_STATUS = {
  google: {
    enabled: true,
  },
  naver: {
    enabled: true,
    warning: '일부 계정은 검수 진행 중이라 제한될 수 있습니다.',
  },
  kakao: {
    enabled: true,
  },
};

export function providerStatus(provider) {
  return SOCIAL_PROVIDER_STATUS[provider] || { enabled: true };
}

// Translates a low-level provider error into a user-friendly message.
// Falls back to the generic "다시 시도해주세요" if the provider's status
// has no specific message (e.g. transient network errors on enabled providers).
export function friendlyProviderError(provider, rawMessage) {
  const status = providerStatus(provider);
  if (!status.enabled && status.message) return status.message;
  return rawMessage || '로그인 중 문제가 발생했습니다. 잠시 후 다시 시도해주세요.';
}
